import { Alert, Button, Form, InputNumber, Typography } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cashier, CashierStatus } from '~/types/Cashier';
import { useUserData } from '~/utils/auth';
import { getCashier } from '~/App/Cashier/api';
import message from '~/utils/message';
import Container from '../../../components/Container';
import { closeCashier } from '../../api';
import { formatDateTime } from '~/utils/date';
import Header from '../../../components/Header';
import { useLoadingSetter } from '~/providers/LoadingProvider';
import { CashierError } from '~/constants/error';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import StickyHeader from '../../../components/StickyHeader';

const CloseCashier = () => {
  const user = useUserData();
  const [cashierData, setCashierData] = useState<Cashier | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { newOrder } = useContext(OrderContext);
  const setLoading = useLoadingSetter();

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await getCashier();
        if (data.status === CashierStatus.Closed) {
          message.success('Kasir sudah ditutup');
          navigate('/');
          return;
        }
        setCashierData(data);
      } catch (e: any) {
        setError(e.errorMsg);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const onFinish = async (values: any) => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await closeCashier({ balance: values.balance });
      navigate(`/report/closing/${data.id}`);
      newOrder();
    } catch (e: any) {
      switch (e.error) {
        case CashierError.NoCashierAndHasOrder:
          setError(
            'Order belum semuanya selesai dan kasir tinggal 1 orang. Selesaikan semua order terlebih dahulu sebelum tutup kasir'
          );
          break;
        default:
          setError(e.errorMsg ?? e.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <StickyHeader>
        <Header title="Tutup Kasir" />
      </StickyHeader>
      <div style={{ padding: 16, position: 'relative' }}>
        {error ? (
          <Alert type="error" message={error} style={{ marginBottom: 16 }} />
        ) : null}
        <div style={{ marginBottom: 12 }}>
          <Typography.Text strong>Kasir: </Typography.Text>
          <Typography.Text>{user?.name}</Typography.Text>
        </div>
        <div className="d-flex flex-column">
          <Typography.Text strong>Waktu Buka Kasir</Typography.Text>
          <Typography.Text>
            {cashierData?.openTime
              ? formatDateTime(cashierData.openTime)
              : null}
          </Typography.Text>
        </div>
        <Form name="closeCashier" onFinish={onFinish} style={{ marginTop: 24 }}>
          <Form.Item
            label="Saldo Akhir"
            name="balance"
            rules={[{ required: true, message: 'Saldo akhir harus diisi' }]}
          >
            <InputNumber style={{ width: '100%' }} size="large" />
          </Form.Item>
          <Form.Item style={{ marginTop: 40 }}>
            <Button type="primary" htmlType="submit" block size="large">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Container>
  );
};

export default CloseCashier;
